/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { GalaxyParent, BoardParent } from 'solis/rpc/parent';

import * as Upcast from 'solis/rpc/upcast';


export const createBoardRoutes = (routes) =>
{
  routes.createDetach('galaxy/boards/:id', (application, { id }) =>
  {
    application.getGalaxy()?.unloadBoard({ id })
  });

  routes.createRecord('galaxy/boards/:id/cass', {
    parent: GalaxyParent,
    load:   (galaxy, cass)   => galaxy.loadBoard(cass),
    unload: (galaxy, { id }) => galaxy.unloadBoard({ id }),
  });

  routes.createTable('galaxy/boards/:board/colonies', {
    parent: BoardParent,
    upcast: [ Upcast.Transform ],
    load:   (board, cass) => board.loadColony(cass),
    unload: (board, cass) => board.unloadColony(cass),
    values: (board) => board.getColonies(),
  });

  routes.createTable('galaxy/boards/:board/sectors', {
    parent: BoardParent,
    upcast: [ Upcast.Transform ],
    key:    (cass) => `${cass.colony}:${cass.id}`,
    load:   (board, cass) => board.loadSector(cass),
    unload: (board, cass) => board.unloadSector(cass),
    values: (board) => board.getSectors(),
  });

  routes.createTable('galaxy/boards/:board/zones', {
    parent: BoardParent,
    upcast: [ Upcast.HexID ],
    key:    (cass) => `${cass.colony}:${cass.sector}:${cass.id}`,
    load:   (board, cass) => board.loadZone(cass),
    unload: (board, cass) => board.unloadZone(cass),
    values: (board) => board.getZones(),
  });

  routes.createTable('galaxy/boards/:board/anchors', {
    parent: BoardParent,
    key:    (cass) => `${cass.sourceColony}:${cass.targetColony}`,
    load:   (board, cass) => board.loadAnchor(cass),
    unload: (board, cass) => board.unloadAnchor(cass),
    values: (board) => board.getAnchors(),
  });

  routes.createTable('galaxy/boards/:board/users', {
    parent: BoardParent,
    load:   (board, cass) => board.loadUser(cass),
    unload: (board, cass) => board.unloadUser(cass),
    values: (board) => board.getUsers(),
  });

  routes.createTable('galaxy/boards/:board/accountViews', {
    parent: BoardParent,
    load:   (board, cass) => board.loadAccountView(cass),
    unload: (board, cass) => board.unloadAccountView(cass),
    values: (board) => board.getAccountViews(),
  });

  routes.createTable('galaxy/boards/:board/influences', {
    parent: BoardParent,
    upcast: [ Upcast.HexTargetZone ],
    key:    (cass) => `${cass.sourceColony}:${cass.targetZone}`,
    load:   (board, cass) => board.loadInfluence(cass),
    unload: (board, cass) => board.unloadInfluence(cass),
    values: (board) => board.getInfluences(),
  });
};
